export { default } from './TeamChatHeader';
